<template>
  <component
    :is="tag"
    :class="[
      defaultClass,
      sizeClass,
      typeClass,
      variantClass,
      (tag === 'inertia-link' || tag === 'a') && 'inline-block',
    ]"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <svg
      :class="[small && 'h-4 w-auto', regular && 'h-5 w-auto', large && 'h-8 w-auto']"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <slot />
    </svg>
  </component>
</template>

<script>
export default {
  props: {
    tag: { type: String, default: 'button' },

    // Size
    small: Boolean,
    regular: Boolean,
    large: Boolean,

    // Type
    action: Boolean,
    primary: Boolean,
    secondary: Boolean,
    link: Boolean,

    // Variant
    disabled: Boolean,
  },

  computed: {
    defaultClass() {
      return 'flex items-center justify-center rounded-full font-medium focus:outline-none transition ease-in-out duration-150';
    },
    sizeClass() {
      if (this.small) return 'h-10 w-10';
      if (this.regular) return 'h-12 w-12';
      if (this.large) return 'h-14 w-14';
    },
    typeClass() {
      if (this.action)
        return 'bg-white border border-gray-200 text-gray-700 hover:text-gray-900 hover:shadow-md focus:shadow-md';
      if (this.primary) return 'bg-navy-600 text-white hover:shadow-md';
      if (this.secondary)
        return 'bg-transparent border border-gray-700 text-gray-800 hover:bg-gray-50';
      if (this.link) return 'bg-transparent text-navy-600 hover:bg-gray-100';
    },
    variantClass() {
      if (this.disabled) return 'opacity-50';
    },
  },
};
</script>
